import {helpers} from '../reportingHelpers';

export class ReportLine {
    render(def, ctx, callback) {
        // We should draw a line across the middle of the control for it's entire width...EK
        let lineY = helpers.getRenderTop(def, ctx) + (def.Height / 2),
            lineStartX = helpers.getRenderLeft(def, ctx),
            lineStopX = lineStartX + def.Width;

        ctx.rootContext.pdf.line(lineStartX, lineY, lineStopX, lineY);
        callback();
    }

    preRender(def, ctx, callback) {
        //This control doesn't change size, no pre-render is needed at this time, just callback...EK
        if (def.runTime == null){
            def.runTime = {top: def.Top};
        }
        else {
            def.runTime.top = def.Top;      // Reset the top in case of growth layout changes...EK
        }
        callback();
    }
}